import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'motion/react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import TopBarSection from './TopBarSection';
import HeroSection from './HeroSection';
import WhoIsSigmatiqaForSection from './WhoIsSigmatiqaForSection';
import MultiHeroPaginationSection from './MultiHeroPaginationSection';
import CompanyCaroselSection from './CompanyCaroselSection';
import DashboardSummarySection from './DashboardSummarySection';
import CaseStudyCalculatorSection from './CaseStudyCalculatorSection';
import StatementsSection from './StatementsSection';
import AccordianSection from './AccordianSection';
import GettingStartedSection from './GettingStartedSection';
import AppSection from './AppSection';
import ReportsSection from './ReportsSection';
import PricingSection from './PricingSection';
import GetInTouchSection from './GetInTouchSection';
import FooterSection from './FooterSection';
import Footer2Section from './Footer2Section';

const sections = [
  { id: 'section-1', content: <TopBarSection /> },
  { id: 'section-2', content: <HeroSection /> },
  { id: 'section-3', content: <WhoIsSigmatiqaForSection /> },
  //{ id: 'section-4', content: <MultiHeroPaginationSection /> },
  { id: 'section-5', content: <CompanyCaroselSection /> },
  { id: 'section-6', content: <DashboardSummarySection /> },
  //{ id: 'section-7', content: <CaseStudyCalculatorSection /> },
  //{ id: 'section-9', content: <AccordianSection /> },
  { id: 'section-10', content: <GettingStartedSection /> },
  //{ id: 'AppSection', content: <AppSection /> },
  //{ id: 'section-12', content: <ReportsSection /> },
 //{ id: 'section-13', content: <PricingSection /> },
  { id: 'section-4', content: <GetInTouchSection /> },
  { id: 'section-5', content: <FooterSection /> },
  { id: 'section-6', content: <Footer2Section /> },
];

const AnimationSection = () => {
  const [prog, setProg] = useState(0);

  const handleScroll = () => {
    const section = document.getElementById("section-5");
    if( section ){
      const rect = section.getBoundingClientRect();
      if( rect ){
        if( rect.top > 0 ) {
          setProg(0);
        } else if( (rect.top + rect.height) < 0 ){
          setProg(1);
        } else {
          setProg(1-((rect.top + rect.height) / rect.height));
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      {sections.map((section, index) => {
        if (section.id === 'AppSection') {
          return (
            <Box
              id="section-5"
              key={section.id}
              sx={{
                height: '400vh', // Section 5 spans 4x height
                position: 'relative'
              }}
            >
              <motion.div
                style={{
                  position: 'sticky',
                  top: 0,
                  height: '100vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {React.cloneElement(section.content, { prog })}
              </motion.div>
            </Box>
          );
        }

        return (
          <Box key={section.id}>
            {section.content}
          </Box>
        );
      })}
    </Box>
  );
};

const MotionDiv = React.forwardRef((props, ref) => (
  <motion.div ref={ref} {...props} />
));

export default AnimationSection;
